import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';

export const onIndividualAgentKnowledgeCardShown = (
	props: commonAttributesType & { agentId: string },
): AnalyticsEventPayload => {
	const { source, agentId } = props;
	return {
		action: 'shown',
		actionSubject: 'aiAgentKnowledgeCard',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			agentId,
		},
	};
};
